import { ContentStateInterface, SaveType } from '../../../@types/types'
import { DispatchType } from '../../../@types/redux-types'
import { tracking } from '../../../tracking/tracking'
import { saveAndProgress } from './saveAndProgress'
import { insertionUpdateRequest } from '../../reducers/insertion/insertionFeature'
import { InitState } from '../../reducers/root/initialState'
import { getDefaultLogger } from '../../../services/logger/logger'

export const doSave = (insertionData: ContentStateInterface, isSubmitBtnClicked: boolean) => {
  return async (dispatch: DispatchType, getState: () => InitState) => {
    if (getState().insertionFeature.save === SaveType.SAVING) {
      return
    }

    dispatch(insertionUpdateRequest())
    getDefaultLogger().info('doSave', { isSubmitBtnClicked })

    const isWaitingListFlow = getState().flowFeature.flowInformation.options?.isWaitingListFlow

    isSubmitBtnClicked &&
      tracking({
        flowInformation: getState().flowFeature.flowInformation,
        eventName: 'submit_complete_button_click',
        entryMode: getState().insertionFeature.insertionIdentification.metaInformation?.entryMode,
        moreEventParameters: {
          ...(isWaitingListFlow ? { event_parameter_2: 'waiting_list' } : {}),
          ga_cd_realestate_object_id: getState().insertionFeature.insertionIdentification.realEstateId?.toString(),
        },
      })
    insertionData.isHomeStreetHomeEnabled &&
      isSubmitBtnClicked &&
      tracking({
        eventName: 'form_submit_homelesspeople_active',
        flowInformation: getState().flowFeature.flowInformation,
      })
    await saveAndProgress(insertionData, isSubmitBtnClicked)(dispatch, getState)
  }
}
